import { supabaseAdapter } from '@/adapters/supabase';

// Define types based on your Supabase schema
export interface IndustryApplication {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  features: string[] | null;
  display_order: number | null;
}

export interface Industry {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  icon_svg: string | null;
  is_active: boolean;
  display_order: number | null;
  applications: IndustryApplication[];
}

/**
 * Fetches all active industries and their active applications from Supabase.
 * Implements caching to reduce database load.
 */
export const getIndustriesWithApplications = async (): Promise<Industry[]> => {
  const { data, error } = await supabaseAdapter.client
    .from('industries')
    .select(`
      *,
      industry_applications (*)
    `)
    .eq('is_active', true)
    .order('display_order', { ascending: true })
    .order('display_order', { foreignTable: 'industry_applications', ascending: true });

  if (error) {
    console.error('Error fetching industries with applications:', error);
    return [];
  }

  // Filter out inactive applications manually
  const industries = data.map(industry => ({
    ...industry,
    applications: industry.industry_applications.filter((app: any) => app.is_active),
  }));

  return industries as Industry[];
};
